import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import ReactDOM from "react-dom"
import React, { useEffect, useState } from "react"

export const ModalOuter = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  overflow: auto;
  display: flex;
`
export const ModalContent = styled.div`
  position: relative;
  font-size: 20px;
  width: 100vw;
  //min-height: 100vh;
  margin: 0 8px;
  padding: 40px 25px;
  background: ${props => props.theme.colors.ash};
  border-radius: 4px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  z-index: 1;

  ${breakpoint("sm")(
    () => css`
      width: ${props => (props.width ? props.width : "490px")};
      max-width: calc(100vw - 30px);
      padding: 40px;
      min-height: unset;
    `
  )}
`
ModalContent.propTypes = {
  width: PropTypes.string,
}
export const ModalBg = styled.div`
  position: fixed;
  display: block;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  content: "\ ";
  z-index: 0;
`
export const ModalCloseButton = styled(props => (
  <button aria-label="close" {...props}>
    <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
      <g
        style={{
          stroke: "currentColor",
          strokeWidth: 2,
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        transform="translate(1 1)"
      >
        <path d="m0 0 9.899495 9.899495" />
        <path
          d="m0 0 9.899495 9.899495"
          transform="matrix(-1 0 0 1 9.899494 0)"
        />
      </g>
    </svg>
  </button>
))`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  appearance: none;
  border: none;
  width: 12px;
  height: 12px;
  padding: 0;
  background: none;
  overflow: hidden;
  z-index: 1;

  svg {
    display: block;
  }
`

const useModalState = ({ startOpen, onClose }) => {
  const [isShown, setIsShown] = useState(startOpen || false)

  const hide = () => {
    onClose && onClose()
    setIsShown(false)
  }
  const show = () => !isShown && setIsShown(true)

  useEffect(() => {
    if (window && isShown) {
      document.body.style.overflow = "hidden"
    }
    if (window && !isShown) {
      document.body.style.overflow = "unset"
    }

    return () => {
      if (window) {
        document.body.style.overflow = "unset"
      }
    }
  }, [isShown])

  return { show, hide, isShown }
}

export const portalRoot =
  typeof document !== `undefined` ? document.getElementById("modal") : null

export const Modal = ({ toggle, startOpen, onClose, ...props }) => {
  const { show, hide, isShown } = useModalState({
    startOpen: startOpen,
    onClose: onClose,
  })

  return (
    <>
      {toggle(show)}

      {isShown &&
        typeof document !== `undefined` &&
        ReactDOM.createPortal(
          <ModalOuter className={props.className}>
            <ModalContent>
              {props.children}
              <ModalCloseButton onClick={hide} />
            </ModalContent>
            <ModalBg
              onClick={() => {
                hide()
              }}
            />
          </ModalOuter>,
          portalRoot
        )}
    </>
  )
}

Modal.propTypes = {
  toggle: PropTypes.func.isRequired,
  startOpen: PropTypes.bool, // pop  modal open when it mounts
  onClose: PropTypes.func, // callback when closed
}

// Toggle(show) should return a react node that calls show() to s how the modal. i.e:
/*
<Modal
  toggle={show => {
    return <button onClick={() => show()}>show modal</button>
  }}
>   this is the modal content :)</Modal>

*/

export const WithModal = ({
  toggle,
  ChildContent,
  className,
  startOpen,
  onClose,
}) => {
  const { show, hide, isShown } = useModalState({
    startOpen: startOpen,
    onClose: onClose,
  })

  return (
    <>
      {toggle && toggle(show)}

      {isShown &&
        typeof document !== `undefined` &&
        ReactDOM.createPortal(
          <ModalOuter className={className}>
            <ModalContent>
              <ChildContent showModal={show} hideModal={hide} />
              <ModalCloseButton onClick={hide} />
            </ModalContent>
            <ModalBg
              onClick={() => {
                hide()
              }}
            />
          </ModalOuter>,
          portalRoot
        )}
    </>
  )
}
WithModal.propTypes = {
  toggle: PropTypes.func,
  ChildContent: PropTypes.func.isRequired,
  className: PropTypes.string,
  startOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
